import React, { useEffect, useState, useRef, useContext } from "react";
import clsx from "clsx";
import styled from "styled-components";
import scrollIntoView from "scroll-into-view";
import { WrapperContext } from "../Layout";
import ImageUI from "./ImageUI";
import MockupUI from "./MockupUI";
import TexteUI from "./TexteUI";
import StoryTexteUI from "./StoryTexteUI";
import StoryItwUI from "./StoryItwUI";
import ProductUI from "./ProductUI";
import PlancheContactUI from "./PlancheContactUI";
// import Product from "../shop/Product";
import { _linkResolver } from "../../core/utils";

const Content = styled.div`
  flex-shrink: 0;
  position: relative;
  height: 100vh;
  width: 0 !important;
  overflow: hidden;
  // opacity: 0;
  transition: width 0.4s ease-in-out, opacity 0.4s ease-in-out;
  transition-timing-function: cubic-bezier(0.37, 0.01, 0, 0.98);

  &.reveal {
    transition-delay: 0.3s;
    opacity: 1;
    width: var(--col-6-13) !important;
  }
  & > section {
    position: absolute;
    height: 100%;
  }
  @media all and (max-width: 1080px) {
    width: 100vw !important;
    height: 0;
    &.reveal {
      height: auto;
      opacity: 1;
      width: 100vw !important;
    }
    & > section {
      position: absolute;
      width: 100vw !important;
      height: 100%;
    }
  }
`;

const TiroirUI = ({ input, open = false }) => {
  // console.log(input);
  const { caption, linkLabel, link } = input;
  // console.log(link);
  // if (!link) return null;
  const { title } = link || "";

  const { isMobile } = useContext(WrapperContext);

  const cardRef = useRef();
  const tiroirRef = useRef();
  const [reveal, setReveal] = useState(open);
  const [loadContent, setLoadContent] = useState(false);
  const [baseLocation, setBaseLocation] = useState();

  useEffect(() => {
    setBaseLocation({
      url: window.location.href,
      title: document.title,
    });
    setLoadContent(true);
  }, []);

  useEffect(() => {
    if (baseLocation) {
      if (reveal) {
        // const rootUrl = window.location.origin;
        const url =
          modules[0]._type === "productUI"
            ? _linkResolver(modules[0].product)
            : _linkResolver(link);
        // const url = `${rootUrl}/${slug.current}`;
        console.log("url", url);
        window.history.pushState({}, title, url);

        const target = isMobile ? tiroirRef.current : cardRef.current;
        const topOffset = isMobile ? 50 : 0;
        document.querySelector(".modules.scrollX").classList.add("no-snap");
        scrollIntoView(
          target,
          {
            time: 500,
            align: {
              left: 0,
              top: 0,
              topOffset: topOffset,
            },
          },
          () => {
            document
              .querySelector(".modules.scrollX")
              .classList.remove("no-snap");
          }
        );
      } else {
        window.history.pushState({}, baseLocation.title, baseLocation.url);
      }
    }
  }, [reveal]);

  const _getModuleByType = (module) => {
    // console.log(module._type);
    switch (module._type) {
      case "imageUI":
        return <ImageUI key={module._key} input={module} showCaption={false} />;
      case "texteUI":
        return <TexteUI key={module._key} input={module} />;
      case "mockupUI":
        return (
          <MockupUI key={module._key} input={module} showCaption={false} />
        );
      case "plancheContactUI":
        return (
          <PlancheContactUI
            key={module._key}
            input={module}
            showCaption={false}
          />
        );
      case "storyTexteUI":
        return <StoryTexteUI key={module._key} input={module} />;
      case "storyItwUI":
        return <StoryItwUI key={module._key} input={module} />;
      case "productUI":
        return <ProductUI key={module._key} input={module} />;
      default:
        return null;
    }
  };

  const _renderIntro = (module) => {
    return _getModuleByType(module);
  };

  const _renderModules = () => {
    if (!modules) return null;

    const _modules = modules.map((module, i) => {
      return _getModuleByType(module);
    });
    return _modules;
  };

  const intro = _renderIntro(link.modules[0]);
  const modules = link.modules.slice(1, link.modules.length);

  // console.log(intro);
  return (
    <>
      <section
        className={clsx(
          "tiroirUI section",
          link.modules[0]._type === "plancheContactUI"
            ? "is-plancheContactUI"
            : ""
        )}
        ref={cardRef}>
        <div
          className='card h-full pointer'
          // onKeyPress={() => setReveal(!reveal)}
          onClick={() => setReveal(!reveal)}
          tabIndex={0}
          role='button'>
          {intro}
          <figcaption className='absolute left-0 bottom-0 p-sm md:p-md w-full text-sm-lg md:text-lg transition-opacity cursor-pointer'>
            <div>{caption}</div>
            <em>{linkLabel}</em>
          </figcaption>
        </div>
      </section>

      {loadContent && (
        <Content
          ref={tiroirRef}
          className={clsx(
            "content section sub-section",
            reveal ? "reveal" : ""
          )}>
          {_renderModules()}
        </Content>
      )}
    </>
  );
};

export default TiroirUI;
